import { AxiosResponse } from 'axios';
import api from './api';

export interface TimeInterval {
    from: Date;
    to: Date;
}
interface RequestFilter {
    fr?: string;
    to?: string;
}

function toRequestFilter(filter: TimeInterval): RequestFilter {
    return {
        fr: filter.from ? filter.from.toISOString() : undefined,
        to: filter.to ? filter.to.toISOString() : undefined,
    };
}

//=================================================================================================
export class DeviceHistoryService {
    static async getHistory(deviceId: number, filter: TimeInterval): Promise<AxiosResponse> {
        const rFilter = toRequestFilter(filter);
        return await api.get('/device-history', { params: { id: deviceId, ...rFilter } });
    }

    static async getLogs(deviceId: number, route: string, count: number): Promise<AxiosResponse<string[]>> {
        return await api.get(`/device-history/logs/${encodeURIComponent(route)}`, {
            params: { id: deviceId, count },
        });
    }
}
